import { useEffect, useRef, useState } from "react";
import Tabs from "./Tabs";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { resetOffCanvasView, updateOffCanvasViewPayload } from "@/store/slices/offCanvas";
import { getUUID } from "@/utils/auth";
import { getMatches } from "@/helpers/api/service/ask";

const TextSearch = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  const [fontSize, setFontSize] = useState<number>(300);
  const [charsDeleted, setCharsDeleted] = useState<number>(0);
  const [searchText, setSearchText] = useState<string>("");

  const inputRef = useRef<HTMLTextAreaElement>(null);

  const onKeyDown = (e: any) => {
    if (!inputRef.current) return;
    if (e.target.value === "") {
      setFontSize(300);
      return;
    }
    if (e.key === "Enter") {
      search();
      return;
    }
    if (inputRef.current.clientHeight < inputRef.current.scrollHeight) {
      setFontSize(fontSize * 0.9);
      return;
    }
    if (e.key === "Backspace") {
      setCharsDeleted(charsDeleted + 1);
      // TODO: check / test this state update
      const newCharsDeleted = charsDeleted + 1;
      if (newCharsDeleted < 8) return;
      setFontSize(Math.min(fontSize / 0.9, 300));
      setCharsDeleted(0);
      return;
    }
  }

  const search = async () => {
    if (!searchText) return;
    const { data } = await getMatches(getUUID(), undefined, undefined, searchText);
    if (!data) return;
    dispatch(updateOffCanvasViewPayload({
      CAMERA: {
        text: searchText,
        questionId: data.question_id,
        matchedQuestions: data.matched_questions ?? [],
      },
    }));
  }

  useEffect(() => {
    if (!inputRef.current) return;
    inputRef.current.focus();
  }, []);

  return (
    <>
      <div className="w-full grow flex flex-col justify-center items-center px-8 py-12 bg-red-300">
        <textarea ref={inputRef} className="bg-transparent text-white h-full w-full text-center outline-none" style={{
          fontSize: `${fontSize}%`,
        }} onChange={(e) => setSearchText(e.target.value)} onKeyDown={onKeyDown} placeholder="Type Your Doubt..." />
      </div>
      <div className="bg-black flex flex-col py-2">
        <Tabs />
        <div className="flex w-full h-32 justify-center items-center">
          <button disabled={!searchText.length} onClick={search} className={`${searchText.length ? "btn-primary" : "btn-disabled"}`}>Find Solution</button>
        </div>
      </div>
    </>
  );
}

export default TextSearch;